import { LocaleStrings } from '../keys';

const vi: LocaleStrings = {
  nav_stories: 'TRUYỆN',
  nav_create: 'SÁNG TẠO',
  nav_login: 'Đăng nhập',
  nav_home: 'Trang chủ',
  nav_search_label: 'Tìm kiếm',
  nav_profile: 'Hồ sơ',
  header_btn_create: 'Tạo Truyện',
  header_user_default: 'Người dùng',
  header_sign_out: 'Đăng xuất',
  search_placeholder: 'Tìm kiếm…',
  theme_toggle_light: 'Chuyển sáng',
  theme_toggle_dark: 'Chuyển tối',

  page_title_main: 'Story Craft - Trang chủ',
  section_browse_by_category: 'Duyệt theo thể loại',
  section_explore_new_games: 'Khám phá trò chơi mới',
  section_popular: 'Phổ biến',
  section_trending: 'Thịnh hành',
  section_trending_now: 'Thịnh hành',
  section_popular_picks: 'Phổ biến',
  section_recent_stories: 'Xem gần đây',
  section_new_stories: 'Truyện mới',
  section_featured: 'Story Craft nổi bật',
  section_top_genre: 'Top truyện {genre}',
  btn_load_more_games: 'Tải thêm ({count} trò chơi nữa)',
  text_showing_games: 'Hiển thị {visible} / {total} trò chơi',
  text_no_category_games: 'Không tìm thấy trò chơi {category}.',
  text_category_games: 'Trò chơi {category}',
  text_error_loading_games: 'Lỗi tải trò chơi: {error}',

  tell_us_tagline: 'Story Craft: Nơi fanfiction trở thành câu chuyện có thể chơi.',
  tell_us_subtitle: 'Bắt đầu trò chơi của bạn ngay hôm nay!',
  btn_create_now: 'Tạo ngay',

  section_comments: 'Bình luận ({count})',
  text_no_comments: 'Chưa có bình luận. Hãy là người đầu tiên chia sẻ suy nghĩ!',
  btn_load_more_comments: 'Tải thêm bình luận',
  text_posting_comment: 'Đang đăng bình luận...',
  text_failed_load_comments: 'Tải bình luận thất bại',
  text_login_to_view_comments: 'Đăng nhập để xem bình luận',

  page_title_game_not_found: 'Không tìm thấy trò chơi - Story Craft',
  page_title_game_info: 'Thông tin trò chơi - Story Craft',
  btn_play_now: 'Chơi ngay',
  btn_edit_story: 'Chỉnh sửa truyện',
  btn_rate: 'Đánh giá',
  section_about: 'Giới thiệu',
  section_tags: 'Thẻ',
  text_views: '{count} lượt xem',
  text_your_rating: 'Đánh giá của bạn: {rating} - {title}',
  text_game_id: 'Mã trò chơi: {id}',
  text_no_description: 'Trò chơi này chưa có mô tả.',
  text_game_not_found: 'Không tìm thấy trò chơi',
  text_failed_load_game: 'Tải thông tin trò chơi thất bại',

  section_similar_games: 'Trò chơi tương tự',
  text_failed_load_similar: 'Tải trò chơi tương tự thất bại',

  hero_eyebrow: '✨ Nền tảng sáng tạo truyện #1',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Khám phá hàng ngàn câu chuyện thú vị từ cộng đồng sáng tạo. Viết, đọc, và chia sẻ những câu chuyện chạm đến trái tim.',
  hero_btn_create: '🚀 Bắt đầu sáng tạo',
  hero_btn_explore: '📖 Khám phá truyện',
  hero_stat_stories: '12,000+ Truyện',
  hero_stat_authors: '5,000+ Tác giả',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Sẵn sàng kể câu chuyện của bạn?',
  prefooter_subtitle: 'Tham gia cùng 5,000+ tác giả đang sáng tạo mỗi ngày trên StoryCraft',
  prefooter_btn_start: '🚀 Bắt đầu miễn phí',
  prefooter_btn_learn: 'Tìm hiểu thêm →',
  footer_tagline: 'Nền tảng sáng tạo truyện #1 Việt Nam',
  footer_terms: 'Điều khoản',
  footer_report: 'Báo cáo',
  footer_contact: 'Liên hệ',

  section_story_craft_comments: 'Bình luận Story Craft - Hỏi và đáp tại đây',

  translate_popup_eyebrow: 'BẢN DỊCH AI',
  translate_popup_title: 'Dịch story sang {targetLang}?',
  translate_popup_message: 'Story này được viết bằng {originLang}. Bạn có muốn mở bằng bản dịch tiếng {targetLang} không?',
  translate_popup_note: 'Bản dịch được tạo tự động bởi AI và có thể chưa hoàn hảo.',
  translate_popup_btn_translate: 'Dịch ngay',
  translate_popup_btn_keep: 'Giữ nguyên',
  translate_progress_title: 'Đang dịch story…',
  translate_progress_subtitle: 'AI đang chuyển sang {targetLang}',
  translate_progress_step_analyze: 'Đang phân tích nội dung…',
  translate_progress_step_generate: 'Đang tạo bản dịch…',
  translate_progress_step_pack: 'Đang cập nhật gói ngôn ngữ…',
  translate_progress_step_done: 'Hoàn tất!',
  translate_progress_flavor_1: 'Đang đọc dialogue…',
  translate_progress_flavor_2: 'Đang dịch lời thoại nhân vật…',
  translate_progress_flavor_3: 'Đang chuyển ngữ các lựa chọn…',
  translate_progress_flavor_4: 'Đang đồng bộ văn phong…',
  translate_progress_flavor_5: 'Đang kiểm tra chính tả…',
  translate_error_title: 'Dịch thất bại',
  translate_error_message: 'Không thể dịch story: {error}. Story sẽ mở bằng ngôn ngữ gốc.',
  translate_error_btn_ok: 'Đã hiểu',

  event_vote_section_title: 'Đang tham gia sự kiện',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Đã vote',
  event_vote_count: '{count} lượt vote',

  section_events: 'Sự kiện',
  btn_event_detail: 'Chi tiết',
  event_ranking_title: 'Bảng xếp hạng truyện',
  event_winners_title: 'Người chiến thắng',
  event_winners_subtitle: 'Top truyện đã nhận huy hiệu từ sự kiện này.',

  event_time_label: 'Thời gian sự kiện',
  event_status_not_started: 'Bắt đầu sau {days} ngày',
  event_status_starting_soon: 'Bắt đầu sau {time}',
  event_status_ended: 'Đã kết thúc',
  event_status_ongoing: 'Còn {days} ngày',
  event_status_ending_soon: 'Còn {time}',
  event_today_label: 'Hôm nay',
  event_day_elapsed: 'Ngày {day}',
  event_total_days: '{days} ngày',
  event_votes_label: 'lượt vote',
  event_not_found: 'Event không tìm thấy hoặc đã kết thúc',
  event_not_found_sub: 'Hãy quay lại trang chủ để xem các event đang diễn ra.',
  event_empty_stories: 'Chưa có story nào tham gia event này',
  event_empty_stories_sub: 'Hãy là người đầu tiên publish story và tham gia!',
  event_modal_title: 'Tham gia sự kiện',
  event_modal_no_events: 'Không có sự kiện nào đang mở.',
  event_modal_joined_badge: 'Đã tham gia',
  event_modal_go_to_event: 'Xem sự kiện',
  event_modal_join_btn: 'Tham gia',
  event_modal_confirm_title: 'Xác nhận tham gia',
  event_modal_confirm_body: 'Bạn có chắc muốn tham gia sự kiện "{name}"? Hành động này không thể hoàn tác.',
  event_modal_confirm_btn: 'Xác nhận tham gia',

  profile_my_profile: 'Trang cá nhân',
  profile_tab_badges: 'Huy Hiệu',
  profile_tab_stories: 'Truyện',
  profile_tab_discussion: 'Thảo Luận',
  profile_tab_notifications: 'Thông Báo',
  profile_notif_empty: 'Chưa có thông báo nào.',
  profile_notif_game_approved: 'Story của bạn đã được duyệt.',
  profile_notif_game_rejected: 'Bản cập nhật story của bạn bị từ chối.',
  profile_notif_new_badge: 'Bạn vừa nhận được huy hiệu mới!',
  profile_coming_soon_title: 'Sắp ra mắt',
  profile_coming_soon_sub: 'Hệ thống Huy Hiệu đang được phát triển. Các thành tựu và danh hiệu của bạn sẽ xuất hiện tại đây.',
  profile_my_stories: 'Truyện của tôi',
  profile_stories_guest: 'Truyện',
  profile_btn_new_story: 'Truyện mới',
  profile_btn_manage: 'Quản lý',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Truyện',
  profile_stat_views: 'Lượt xem',
  profile_stat_star: 'Top Star',
  profile_btn_follow: '+ Theo dõi',
  profile_btn_message: 'Nhắn tin',
  profile_discussion_placeholder: 'Để lại lời nhắn cho tác giả...',
  profile_discussion_login: 'Đăng nhập để bình luận',
  profile_btn_send: 'Gửi',
  profile_btn_reply: 'Trả lời',
  profile_btn_hide_comment: 'Ẩn',
  profile_btn_show_comment: 'Hiện',
  profile_no_comments: 'Chưa có bình luận nào. Hãy là người đầu tiên!',
  profile_load_more: 'Tải thêm',
  profile_edit_title: 'Chỉnh sửa hồ sơ',
  profile_edit_change_avatar: 'Đổi ảnh đại diện',
  profile_upload_avatar_error: 'Tải ảnh đại diện thất bại. Vui lòng thử lại.',
  profile_edit_fullname: 'Họ và tên',
  profile_edit_bio: 'Giới thiệu bản thân',
  profile_edit_save: 'Lưu',
  profile_shelf_empty: 'Chưa có truyện nào',
  profile_shelf_empty_sub: 'Tạo story đầu tiên của bạn trên StoryCraft Studio. Chỉ mất vài phút để xuất bản.',
  profile_btn_create_first: 'Tạo story đầu tiên',
  profile_btn_load_more_stories: 'Tải thêm truyện',
  profile_save_error: 'Không thể lưu hồ sơ. Vui lòng thử lại.',
  profile_hide_error: 'Ẩn bình luận thất bại.',
  profile_comment_error: 'Gửi bình luận thất bại. Vui lòng thử lại.',
  profile_reply_error: 'Gửi trả lời thất bại. Vui lòng thử lại.',
  profile_btn_cancel: 'Hủy',
  profile_btn_logout: 'Đăng xuất',
  profile_logout_confirm_title: 'Đăng xuất?',
  profile_logout_confirm_body: 'Bạn có chắc muốn đăng xuất khỏi tài khoản này? Bạn sẽ được đưa về trang chủ.',
  profile_login_required_title: 'Bạn chưa đăng nhập',
  profile_login_required_body: 'Đăng nhập để xem hồ sơ, truyện đã tạo và huy hiệu của bạn.',

  badge_achievements_title: 'Thành tựu thường',
  badge_reader: 'Reader',
  badge_writer: 'Writer',
  badge_tier_locked: 'Chưa đạt',
  badge_tier_max: 'Đã đạt tối đa',
  badge_special_earned: '✓ Đã đạt',
  badge_count: '{earned} / {total} huy hiệu',
  badge_load_error: 'Không thể tải dữ liệu',
  badge_retry: 'Thử lại',
  badge_event_section: 'Event Badges',
  badge_section_normal: 'Huy hiệu',
  badge_empty: 'Chưa có huy hiệu nào',
  badge_empty_sub: 'Hãy tham gia các sự kiện và sáng tạo nội dung để nhận huy hiệu đầu tiên.',
  badge_tier_special_label: '★ Special',
  achievement_desc_play_number_game: 'Đọc {count} câu chuyện',
  achievement_desc_comment_number_game: 'Bình luận trên {count} câu chuyện',
  achievement_desc_ending_seeker: 'Tìm thấy kết thúc của {count} câu chuyện',
  achievement_desc_publish_story: 'Xuất bản câu chuyện đầu tiên của bạn',
  achievement_desc_reach_views: 'Câu chuyện của bạn đạt {count} lượt xem',
  achievement_desc_reach_number_5star_vote: 'Câu chuyện của bạn nhận được {count} đánh giá tốt',

  rating_warn_title: 'Phân loại {rating}',
  rating_warn_teen_body: 'Story này được phân loại T (Teen 13+). Có thể chứa nội dung bạo lực nhẹ, chủ đề gợi cảm hoặc không phù hợp với độc giả nhỏ tuổi.',
  rating_warn_mature_body: 'Story này được phân loại M (Mature 18+). Có thể chứa nội dung bạo lực mạnh, chủ đề người lớn hoặc nội dung chỉ dành cho độc giả trưởng thành.',
  rating_warn_continue: 'Tiếp tục',
  rating_warn_go_back: 'Quay lại',
  rating_warn_confirm_teen: 'Tôi xác nhận mình từ 13 tuổi trở lên.',
  rating_warn_confirm_mature: 'Tôi xác nhận mình từ 18 tuổi trở lên.',

  rating_section_title: 'Phân loại nội dung',
  rating_label_e: 'Mọi lứa tuổi',
  rating_label_t: 'Tuổi teen 13+',
  rating_label_m: 'Người lớn 18+',
  rating_desc_e: 'Phù hợp với độc giả mọi lứa tuổi. Nội dung phù hợp với tất cả mọi người.',

  hero_dialog_1: 'Harry Potter vô tình đọc nhầm thần chú vào story của bạn rồi.',
  hero_dialog_2: 'Sherazade vẫn đang kể cho Mina một câu chuyện cuối trước khi mặt trời mọc…',
  hero_dialog_3: 'Sherlock Holmes phát hiện plot hole bị mất và từ chối tải tiếp.',
  hero_dialog_4: 'Dracula đang chờ xin phép để vào chương 2.',
  hero_dialog_5: 'Frodo không biết làm thế nào đã đánh rơi file lưu của bạn vào Núi Doom.',
  hero_dialog_6: 'Harry Potter và Mina đang cãi nhau xem ai gây ra sự sụp đổ timeline.',
  hero_dialog_7: 'Cinderella lại lỡ mất nửa đêm rồi, nên màn hình loading bị kéo dài thêm.',
  hero_dialog_8: 'Romeo và Juliet đến bad ending của bạn hơi sớm một chút.',
  hero_dialog_9: 'Alice mở nhầm cái hố thỏ và lọt vào thư mục bản nháp của bạn.',
  hero_dialog_10: 'Mina hứa sẽ không đọc sách cấm nữa. Mina đã nói dối.',
  hero_dialog_11: 'Merlin đang vá một bug ma thuật trong story engine.',
  hero_dialog_12: 'Odysseus đã cố gắng đến chương tiếp theo suốt 10 năm.',
  hero_dialog_13: 'Dr. Frankenstein chạm vào codebase. Không ai còn cảm thấy an toàn nữa.',
  hero_dialog_14: 'Peter Pan từ chối để story này lớn lên.',
  hero_dialog_15: 'Hoàng Tử Bé hỏi Mina tại sao người lớn lại viết nhiều kết thúc bi kịch thế.',

  // AI-generated games
  section_ai_games: 'Game Tương tác chủ động',
  section_ai_games_gradient_word: 'Tương tác',
  section_ai_games_subtitle: 'Tự viết hội thoại, trò chuyện với NPC và mở khóa vô hạn ending cho story',
  section_ai_games_keywords: 'trò chuyện với NPC|vô hạn ending',
  badge_ai_game: 'AI Game',
  text_created_days_ago: 'Tạo {days} ngày trước',
  text_created_today: 'Tạo hôm nay',
  text_ai_game_disclaimer: 'Game này do Mina AI sinh ra. Đánh giá, bình luận và đề xuất game tương tự chưa khả dụng.',
  text_no_ai_games: 'Chưa có game AI nào. Mina vẫn đang khởi động.',
  text_failed_load_ai_games: 'Không tải được game AI. Vui lòng thử lại.',
  page_title_ai_game: 'Game AI · Story Craft',
  btn_play_ai_game: 'Chơi game',
};

export default vi;
